// extracted by mini-css-extract-plugin
export default {"wrap":"OrdersOrdersMenuDatesComponent_wrap__dUFfk","blockForm":"OrdersOrdersMenuDatesComponent_blockForm__wHSgf"};